export default __webpack_public_path__ + "static/media/element2Card.135be66c.svg";